<button
  type="button"
  class="info-icon-btn"
  (click)="onQaButtonClick()"
  [ngbTooltip]="isSchemaView ? schemaTooltip : (isDatasetView ? datasetTooltip : (status === 'ready' ? infoTooltip : null))"
  [triggers]="(isSchemaView || isDatasetView) ? 'hover' : 'click'"
  placement="bottom"
  [openDelay]="200"
  [closeDelay]="100"
  [disabled]="isBlocked"
  [attr.aria-busy]="(isSchemaView ? schemaStatus : (isDatasetView ? datasetStatus : status)) === 'loading'"
>
  <ng-container *ngIf="(isSchemaView ? schemaStatus : (isDatasetView ? datasetStatus : status)) === 'loading'; else infoIcon">
    <span class="spinner-border spinner-border-sm qa-info-spinner" role="status" aria-hidden="true"></span>
  </ng-container>
  <ng-template #infoIcon>
    <i class="bi bi-info-circle"></i>
  </ng-template>
</button>

<ng-template #schemaTooltip>
  <div class="tooltip-inner d-flex flex-column align-items-start text-start">
    <p class="mb-1 fw-semibold">Schema QA Overview</p>
    <p class="mb-1"><strong>Fields unstable: </strong>—</p>
    <p class="mb-1"><strong>Fields with frequent unexpected change: </strong>—</p>
    <p class="mb-1"><strong>Fields missing despite expected "Common": </strong>—</p>
  </div>
</ng-template>

<ng-template #datasetTooltip>
  <div class="tooltip-inner d-flex flex-column align-items-start text-start">
    <p class="mb-1 fw-semibold">QA Summary (Dataspace)</p>
    <ng-container [ngSwitch]="datasetStatus">
      <ng-container *ngSwitchCase="'loading'">
        <p class="mb-0 text-muted">Loading...</p>
      </ng-container>
      <ng-container *ngSwitchCase="'error'">
        <p class="mb-0 text-muted">{{ datasetErrorMessage || 'Unavailable' }}</p>
      </ng-container>
      <ng-container *ngSwitchCase="'ready'">
        <p class="mb-2 small">Compared vs previous batch</p>
        <div class="d-flex flex-column align-items-start text-start" *ngIf="datasetConsistency">
          <p class="mb-1"><strong>Overall: </strong>{{ datasetConsistency.overall_percentage ?? '—' }}%</p>
          <p class="mb-1"><strong>Level: </strong>{{ datasetConsistency.level ?? '—' }}</p>
          <p class="mb-1"><strong>Quality: </strong>{{ datasetConsistency.quality ?? '—' }}</p>
          <p class="mb-1"><strong>Total paths: </strong>{{ datasetConsistency.total_paths ?? '—' }}</p>
          <ng-container *ngIf="datasetConsistency.penalty_breakdown as pb">
            <p class="mb-1"><strong>Penalty breakdown:</strong></p>
            <p class="mb-1 ms-2">all_match: {{ pb.all_match ?? '—' }}, value_different: {{ pb.value_different ?? '—' }}, missing_key: {{ pb.missing_key ?? '—' }}</p>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <p class="mb-0 text-muted">Hover to load</p>
      </ng-container>
    </ng-container>
  </div>
</ng-template>

<ng-template #infoTooltip>
  <div class="tooltip-inner d-flex flex-column align-items-start text-start">
    <ng-container [ngSwitch]="status">
      <ng-container *ngSwitchCase="'loading'">
        <p class="mb-1 fw-semibold">QA Summary (This Document)</p>
        <p class="mb-0 text-muted">Loading...</p>
      </ng-container>
      <ng-container *ngSwitchCase="'error'">
        <p class="mb-1 fw-semibold">QA Summary (This Document)</p>
        <p class="mb-0 text-muted">{{ errorMessage || 'Unavailable' }}</p>
      </ng-container>
      <ng-container *ngSwitchCase="'ready'">
        <p class="mb-1 fw-semibold">QA Summary (This Document)</p>
        <p class="mb-2 small">Compared vs previous run</p>
        <div class="d-flex flex-column align-items-start text-start">
          <p class="mb-1"><strong>Job ID: </strong>{{documentDataFileInfo?.jobId}}</p>
          <p class="mb-1"><strong>Score: </strong>{{documentDataFileInfo?.score}}</p>
          <p class="mb-1"><strong>Quality: </strong>{{documentDataFileInfo?.quality}}</p>
          <p class="mb-1"><strong>Summary: </strong>{{documentDataFileInfo?.summary?.total_fields}} fields, {{documentDataFileInfo?.summary?.fields_with_value}} with value, {{documentDataFileInfo?.summary?.fields_empty}} empty</p>
        </div>
        <hr class="my-2">
        <div class="d-flex flex-column align-items-start text-start">
          <p class="mb-1 fw-semibold">Consistency:</p>
          <p class="mb-1"><strong>Overall: </strong>{{ summary?.consistency?.overall_percentage ?? '—' }}%</p>
          <p class="mb-1"><strong>Level: </strong>{{ summary?.consistency?.level ?? '—' }}</p>
          <p class="mb-1"><strong>Quality: </strong>{{ summary?.consistency?.quality ?? '—' }}</p>
          <p class="mb-1"><strong>Total paths: </strong>{{ summary?.consistency?.total_paths ?? '—' }}</p>
          <ng-container *ngIf="summary?.consistency?.penalty_breakdown as pb">
            <p class="mb-1"><strong>Penalty breakdown:</strong></p>
            <p class="mb-1 ms-2">all_match: {{ pb.all_match ?? '—' }}, value_different: {{ pb.value_different ?? '—' }}, missing_key: {{ pb.missing_key ?? '—' }}</p>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngSwitchDefault>
        <p class="mb-1 fw-semibold">QA Summary (This Document)</p>
        <p class="mb-0 text-muted">Hover to load</p>
      </ng-container>
    </ng-container>
  </div>
</ng-template>
